import { resolve } from "inversify-react";
import * as React from "react";
import Dropzone, { FileWithPreview } from "react-dropzone";
import ToastService from "src/services/toast.service";
import {container} from "../../inversify.config";
import FileSystemService from "../../services/filesystem.service";
import Icon from "./icon";
import { IFileSystemService, IImage } from "../../typings";

type FileType = "image" | "application";

export interface UploadProps {
    minified?: boolean;
    style?: React.CSSProperties;
    onUpload?: (image: IImage) => void;
    onDelete?: () => void;
    proof?: boolean;
    value?: IImage | string | null;
    fileSystem?: IFileSystemService;
    fileTypes?: FileType[];
}

export interface UploadState {
    image?: any;
    base64?: any;
}

export default class Upload extends React.Component<UploadProps, UploadState> {
    public fileSystemService: IFileSystemService;

    @resolve(ToastService)
    public toastService: ToastService;

    constructor(props: UploadProps) {
        super(props);
        this.state = {};
    }

    public renderFull = () => {
        const identity = this.props;
    return (
        <React.Fragment>
            <h3 className="upload-title">Drag and Drop</h3>
            <p className="upload-description">Your file, or browse</p>
            <p className="upload-extense">Upload a JPEG, JPG, PNG  of your Identity Document. Maximum file size 30MB</p>
        </React.Fragment>
    );
  }

    formatFileTypes(): string {
        const { fileTypes } = this.props;

        let types = "";
        if(fileTypes) {
            fileTypes.forEach((type: string, index: number) => {
                if(index < fileTypes.length - 1) types += type + ", ";
                else types += type + ".";
            })
        }
        return types;
    }

    public onDrop = (images: FileWithPreview[]) => {
        if (!this.props.fileTypes || this.props.fileTypes.some((type) => images[0].type.startsWith(type))) {
            this.setState({image: images[0], base64: images[0]});
            this.fileSystemService.uploadFile<IImage>(images[0]).then((iimage) => {
                if (this.props.onUpload) {
                    this.props.onUpload(iimage);
                }
            });
        } else {
            this.toastService.showToast("Unsupported type", "File must be of type " + this.formatFileTypes(), "error");
        }
  }

    public removeFile = (e?: any) => {
      if (e) {
        e.preventDefault();
      }

      this.setState({image: undefined});

      if (this.props.onDelete) {
        this.props.onDelete();
      }
  }

    public componentDidMount() {

      if (!this.props.fileSystem) {
          this.fileSystemService = container.get<FileSystemService>(FileSystemService);
      } else {
        this.fileSystemService = this.props.fileSystem;
      }

      if (this.props.value) {
          this.fileSystemService.getFile<IImage>(this.props.value).then((result) => {
              this.setState({image: {preview:  result.image ? result.image : result}});

          });
      }
  }

    public componentWillReceiveProps(nextProps: UploadProps) {
      if (nextProps.value && nextProps.value !== this.props.value) {
        this.fileSystemService.getFile<IImage>(nextProps.value).then((result) => {
            // console.log(result);
            this.setState({image: {preview:  result.image ? result.image : result}});
        })
        .catch((error) => {});
      }
  }

    public render() {
    return (
        <div className={"upload " + (this.props.minified ? "minified " : " ") + (this.state.image && this.props.proof ? "white" : "")}>
        {!this.state.image &&
            <Dropzone onDrop={this.onDrop} multiple={false} className="upload-component">
                <div className="circle small slate iconified white">
                    <Icon className="" type="upload"/>
                </div>
                {!this.props.minified && this.renderFull()}
            </Dropzone>}
        {this.state.image &&
            <img
                className="up-preview"
                src={this.state.base64 ? this.state.base64.preview : this.state.image.preview}
            />
        }
        {this.state.image &&
            <div className="remove-btn">
                <div className="circle small yellow iconified white">
                    <Icon type="close" onClick={this.removeFile}  />
                </div>
                <p className="remove-text">Remove photo</p>
            </div>
        }
    </div>
    );
  }
}

export class ImageUpload extends Upload {
    public onDrop = (images: FileWithPreview[]) => {
        if(images[0].type.startsWith("image")) {
            this.setState({image: images[0], base64: images[0]});
            this.fileSystemService.uploadFile<IImage>(images[0]).then((iimage) => {
                if (this.props.onUpload) {
                    this.props.onUpload(iimage);
                }
            });
        } else {
            this.toastService.showToast("Unsupported type", "File must be of type image", "error");
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/upload.tsx